// src/pages/MasterDataPage.jsx
import React from "react";
import { useParams } from "react-router-dom";
import Layout from "../layout/builders/Layout"; // Using builder layout for now, adjust if needed
import MasterDataDisplay from "../layout/common/MasterDataDisplay"; // Create this next
import ProjectBanner from "../layout/builders/ProjectBanner"; // Optional banner

const MasterDataPage = () => {
  const { projectId } = useParams(); // Get projectId from URL

  return (
    <div style={{ backgroundColor: "#E0E0E0" }}>
      <Layout>
        {/* Optional: Add a banner */}
        <ProjectBanner
          title={`Master Data for Project #${projectId}`}
          // imageUrl="https://via.placeholder.com/1200x300" // Or a relevant image
        />
        <div className="p-4">
          {projectId ? (
            <MasterDataDisplay projectId={projectId} />
          ) : (
            <p className="text-red-500 text-center">Invalid Project ID.</p>
          )}
        </div>
      </Layout>
    </div>
  );
};

export default MasterDataPage;